import { useRef, useState } from "react";
import { ImagePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError, imgSrc } from "@/lib/api";

export const ImageUpload = ({ value, onChange }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) { toast.error("Image must be under 8 MB"); return; }
    const form = new FormData();
    form.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post("/admin/upload", form);
      onChange(data.url);
      toast.success("Photo uploaded");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
      if (input.current) input.current.value = "";
    }
  };

  return (
    <div>
      <button type="button" onClick={() => input.current?.click()} data-testid="admin-image-upload-btn"
        className="spec-frame group relative flex aspect-square w-full items-center justify-center overflow-hidden border border-dashed border-black/30 hover:border-[#FF5A00]">
        {value
          ? <img src={imgSrc(value)} alt="Product" data-testid="admin-image-preview" className="absolute inset-[8%] h-[84%] w-[84%] object-contain" />
          : <span className="flex flex-col items-center gap-2 font-mono text-xs uppercase tracking-[0.15em] text-zinc-700"><ImagePlus className="h-8 w-8" />Upload photo</span>}
        <span className="absolute inset-x-0 bottom-0 flex items-center justify-center gap-2 bg-[#0B0B0B]/85 py-3 font-mono text-xs uppercase tracking-[0.15em] text-white">
          {busy ? <><Loader2 className="h-4 w-4 animate-spin" /> Uploading…</> : value ? "Change photo" : "Choose file"}
        </span>
      </button>
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" data-testid="admin-image-input" onChange={(e) => upload(e.target.files?.[0])} />
      <p className="mt-2 text-xs text-zinc-600">JPG, PNG or WEBP, up to 8 MB. A square photo on a plain background looks best.</p>
    </div>
  );
};
